var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from "react";
import { observer } from "mobx-react";
import { useLocalObservable } from "mobx-react-lite";
import { useHistory, useLocation } from "react-router-dom";
import LoadingSpinner from "@gcp-artifact/compass/lib/components/updated/loadingSpinner";
import { AuthLayout } from "@/components/AuthLayout";
import api from "@/api/admin";
import MPStorage from "@/services/LocalStorage";
import translate from "@/utilities/i18n/getTranslate";
import { k } from "@/utilities/i18n";
import useAdminStore from "@/services/store/useAdminStore";
import errorHandler from "@/utilities/errorHandler";
import useLogout from "@/utilities/hooks/useLogout";
import { replacePlaceholderStringBold, replacePlaceholderWithTextButton, } from "@/utilities/replacePlaceholder";
var REDIRECT_DELAY = 5;
var AuthVerifyEmail = function () {
    var history = useHistory();
    var location = useLocation();
    var adminNotification = useAdminStore().adminNotification;
    var logout = useLogout().logout;
    var _a = __read(React.useState(null), 2), countdown = _a[0], setCountdown = _a[1];
    var countdownStarted = React.useRef(false);
    var _b = MPStorage.requestCacheAuthenticate(), token = _b.token, isTokenExpired = _b.isTokenExpired;
    var isAuthenticated = !!token && token !== "undefined" && !isTokenExpired;
    var localStore = useLocalObservable(function () { return ({
        email: "",
        isLoading: true,
        isResending: false,
    }); });
    var startCountdown = React.useCallback(function () {
        if (countdownStarted.current)
            return;
        countdownStarted.current = true;
        setCountdown(REDIRECT_DELAY);
    }, []);
    React.useEffect(function () {
        var _a, _b;
        if (countdown === null)
            return;
        if (countdown === 0) {
            history.replace((_b = (_a = location.state) === null || _a === void 0 ? void 0 : _a.returnTo) !== null && _b !== void 0 ? _b : "/auth/signup/partner");
            return;
        }
        var timer = setTimeout(function () { return setCountdown(function (c) { return (c !== null && c !== void 0 ? c : 0) - 1; }); }, 1000);
        return function () { return clearTimeout(timer); };
    }, [countdown]);
    React.useEffect(function () {
        // Unauthenticated visitors (e.g. clicking the email link while logged out)
        // skip the API check and go straight to the verified + countdown view.
        if (!isAuthenticated) {
            startCountdown();
            localStore.isLoading = false;
            return;
        }
        var init = function () { return __awaiter(void 0, void 0, void 0, function () {
            var data, err_1;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api.profile.checkEmailVerification({
                                bypassCache: true,
                            })];
                    case 1:
                        data = _c.sent();
                        localStore.email = (_a = data.email) !== null && _a !== void 0 ? _a : "";
                        localStore.isLoading = false;
                        if (data.emailVerified) {
                            startCountdown();
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _c.sent();
                        localStore.isLoading = false;
                        if ([401, 500].includes((_b = err_1.response) === null || _b === void 0 ? void 0 : _b.status)) {
                            logout();
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        init();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var handleResend = function () { return __awaiter(void 0, void 0, void 0, function () {
        var err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    localStore.isResending = true;
                    return [4 /*yield*/, api.profile.requestEmailVerification()];
                case 1:
                    _a.sent();
                    adminNotification.add({
                        type: adminNotification.types.SUCCESS,
                        message: "".concat(translate(k.AUTH_emailSentTo), " ").concat(localStore.email),
                    });
                    return [3 /*break*/, 4];
                case 2:
                    err_2 = _a.sent();
                    adminNotification.add({
                        type: adminNotification.types.ERROR,
                        timeoutToClose: 10,
                        message: errorHandler(err_2),
                    });
                    return [3 /*break*/, 4];
                case 3:
                    localStore.isResending = false;
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    if (localStore.isLoading) {
        return React.createElement(LoadingSpinner, null);
    }
    if (countdown !== null) {
        return (React.createElement(AuthLayout, { title: translate(k.AUTH_emailVerification), description: translate(k.AUTH_emailVerifiedSuccess) },
            React.createElement("div", { style: { fontSize: "var(--font-size-s)" } },
                translate(k.AUTH_redirectingIn),
                " ",
                countdown,
                "s...")));
    }
    return (React.createElement(AuthLayout, { title: translate(k.AUTH_emailVerification), showLogOutButton: true, description: React.createElement("div", null, replacePlaceholderStringBold(translate(k.AUTH_OTPSent), "<EMAIL>", "- ".concat(localStore.email))) },
        React.createElement("div", { style: { fontSize: "var(--font-size-s)" } }, replacePlaceholderWithTextButton(translate(k.AUTH_cannotSeeEmail), handleResend, "secondary", true))));
};
export default observer(AuthVerifyEmail);
//# sourceMappingURL=data:application/json;base64,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